export const endpoints = {
  credit: {
    actions: '/credit/actions',
    amount: '/credit/amount',
    featuresSteps: '/credit/features-steps',
    overdue: '/credit/overdue',
    terminate: '/credit/terminate',
    tierMigration: {
      root: '/credit/tier-migration',
      tierMigrationId: (tierMigrationId = ':tierMigrationId') =>
        `/credit/tier-migration/${tierMigrationId}` as const
    }
  },
  paymentProvider: {
    account: '/payment-provider/account',
    directPayment: {
      paymentId: (paymentId = ':paymentId') =>
        ({
          root: `/payment-provider/direct-payment/${paymentId}`,
          paymentRequest: `/payment-provider/direct-payment/${paymentId}/payment-request`,
          generateQr: `/payment-provider/direct-payment/${paymentId}/generate-qr`
        }) as const
    }
  },
  user: {
    addonProducts: {
      idProtect: '/user/addon-products/id-protect',
      paymentProtectionInsurance: '/user/addon-products/payment-protection-insurance'
    }
  },
  users: {
    me: '/users/me'
  },
  SE: {
    addonProducts: {
      idProtect: '/se/addon-products/id-protect',
      paymentProtectionInsurance: '/se/addon-products/payment-protection-insurance'
    },
    loan: {
      applications: {
        applicationId: (applicationId = ':applicationId') =>
          ({
            signOffer: `/se/loan/applications/${applicationId}/sign-offer`,
            acceptOffer: `/se/loan/applications/${applicationId}/accept-offer`
          }) as const
      },
      withdrawalStatus: '/se/loan/withdrawal-status'
    }
  }
} as const;
